import { Text, ChevronArrow } from '@instamenu/ui-system-next';
import { cardButtonStyle } from './card-button.css';
import { MouseEventHandler } from 'react';

export interface CardButtonProps {
  isOpen?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  label?: string;
  children?: React.ReactNode;
}

export function CardButton({ onClick, label, children, isOpen }: CardButtonProps) {
  return (
    <div className={cardButtonStyle} onClick={onClick}>
      <Text variant="caption1">{label}</Text>
      {children}
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
        <ChevronArrow isOpen={isOpen} />
      </div>
    </div>
  );
}
